import FormLabel from '@mui/material/FormLabel'

export default FormLabel
